import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { listModels } from "../api/listModels";
import { listModelUsage } from "../api/listModelUsage";

/** The model catalog. Rarely changes, so a long stale time. */
export function useModels() {
  return useQuery({
    queryKey: queryKeys.chat.models(),
    queryFn: listModels,
    staleTime: 5 * 60_000,
  });
}

/** Recently used models, for the picker's "Recently used" section + defaulting. */
export function useModelUsage() {
  return useQuery({
    queryKey: queryKeys.chat.modelUsage(),
    queryFn: listModelUsage,
    staleTime: 60_000,
  });
}
